const Scheduled = {

    // FIELDS
    "creation_mode": "Creation Mode",
    "manual": "Manual",
    "automatic": "Automatic",
    "start_date": "Start Date",
    "assign_to": "Assign To",
    "calendar_cycle_at": "Calendar Cycle At",
    "number_of_cycles": "Number of Cycles",
    "week": "Week",
    "month": "Month",
    "year": "Year",

    // PAGE HEADER
    "schedule_maintenance": "Schedule Maintenance",
    "scheduled_maintenance": "Scheduled Maintenance",
    "maintenance_scheduled": "Maintenance Scheduled",

    // TABS
    "current_month": "Current Month",
    "pending": "Pending",
    "upcoming": "Upcoming",
    "complete": "Complete",
    "all": "All",
    "start": "Start",
    "hold": "Hold",
    "completed": "Completed",
    "rescheduled": "Rescheduled",

    // FILTER FIELDS
    "department": "Department",
    "location": "Location",
    "equipment": "Equipment",
    "make": "Make",
    "part_number": "Part Number",
    "job_card_number": "Job Card Number",

    // TABLE HEADERS
    "table_status": "STATUS",
    "table_component": "COMPONENT",
    "table_equipment": "EQUIPMENT",
    "table_make": "MAKE",
    "table_new_part_number": "NEW PART NUMBER",
    "table_old_part_number": "OLD PART NUMBER",
    "table_km_item_code": "KM ITEM CODE",
    "table_location": "LOCATION",
    "table_department": "DEPARTMENT",
    "table_job_card_number": "JOB CARD NUMBER",
    "table_timeline": "TIMELINE",
    "table_type": "TYPE",
    "table_schedule_type": "SCHEDULE TYPE",
    "table_maintenance_date": "MAINT. DATE",
    "table_start_date": "START DATE",
    "table_assigned_to": "ASSIGNED TO",
    "table_equipment_details": "EQUIPMENT DETAILS",
    "table_oc_generated": "OC GENERATED",
    "table_oc_latest": "OC LATEST",

    // DETAILS
    "component": "Component",
    "status": "Status",
    "organization_name": "Organization Name",
    "job_card_number": "Job Card Number",
    "timeline": "Timeline",
    "type": "Type",
    "schedule_type": "Schedule Type",
    "maintenance_date": "Maintenance Date",
    "ticket_status": "Ticket Status",
    "notes": "Notes",

    // ERROR
    "error_creation_mode": "Select Creation Mode",
    "error_start_date": "Select Start Date",
    "error_assign_to": "Select Staff to Assign",
    "error_calendar_cycle_at": "Enter Calendar Cycle At",
    "error_calendar_cycle_type": "Select Cycle Type",
    "error_number_of_cycles": "Enter Number of Cycles",
    "error_positive_number": "Enter a positive number",
    "error_reason": "Please enter a reason to hold",
    "error_reschedule_date": "Please select a date to reschedule",
    "reason": "Reason",
    "reschedule_date": "Reschedule Date",
    "object_condition": "Object Condition",
    "error_object_condition": "Select Object Condition",
    "object_condition_generated": "Object Condition Generated",
    "object_condition_latest": "Object Condition Latest",

    // ACTIONS
    "start": "Start",
    "hold": "Hold",
    "stop": "Stop",
    "reschedule": "Reschedule",
    "prospective_date": "Prospective Date",

    // CONFIRMATION MESSAGES
    "start_confirm": "Are you sure you want to start the maintenance?",
    "hold_confirm": "Are you sure you want to hold the maintenance?",
    "stop_confirm": "Are you sure you want to complete the maintenance?",
    "reschedule_confirm": "Are you sure you want to reschedule the maintenance?",
    "prospective_date_confirm": "Are you sure you want to set a prospective date for the maintenance?",
    "prospective_date_label": "Prospective Date",

    // SUCCESS MESSAGES
    "start_success": "Started Successfully",
    "hold_success": "Hold Successfully",
    "stop_success": "Stopped Successfully",
    "reschedule_success": "Rescheduled Successfully",
    "prospective_date_success": "Prospective Date Set Successfully",

    // ERROR MESSAGES
    "error_prospective_date": "Please select a prospective date",

    // LOGS
    "log_type": "LOG TYPE",
    "log_description": "DESCRIPTION",
    "log_user_name": "USER NAME",
    "log_date": "ACTIVITY DATE",
    "log_reschedule_date": "RESCHEDULE DATE",

}

export default Scheduled;